import { watch } from 'vue';
import { B2CClientService } from '@/b2c/shared/api/server-apis';
import useBasket from '@/b2c/basket/useBasket';
import utilitiesService from '@/shared/utilities.service';
import { useBasketUpsell } from '@/shared/product/upsell/useBasketUpsell';
import { ProductSpotModel } from '@/types/productServerApi';

export const upSellItemsCancellationKey = 'upSellItemsCancellationKey';

const { basket, upSellItemCounter } = useBasket();
const { setUpsellSkuRelationsForBasket, fetchUpsellItemProductModel, getUpsellItemsForLineItem, getUpsellItemsFoundInBasket } = useBasketUpsell();

const fetchUpSellData = async(): Promise<void> => {
    if (basket.value.basketId) {
        const upsellSkuRelations = await B2CClientService.getUpSellProducts(basket.value.basketId, upSellItemsCancellationKey).then(utilitiesService.unwrapModel);
        setUpsellSkuRelationsForBasket(upsellSkuRelations);
        await fetchUpsellItemProductModel();
    }
};

watch(upSellItemCounter, fetchUpSellData, { immediate: true });

export function useUpSellItems() {
    const getUpsellItems = (lineItemId: number): ProductSpotModel[] | undefined => {
        return getUpsellItemsForLineItem(lineItemId);
    };

    return {
        getUpsellItems,
        getUpsellItemsFoundInBasket,
    };
}
